import classNames         from 'classnames';
import * as React         from 'react';
import { useTranslation } from 'react-i18next';
import { Link }           from 'react-router-dom';

import { FooterCookieBrowsersLinks } from '../footer/components';
import { useSiteSettings }           from '../../providers/siteSettings';
import { useCommon }                 from '../../providers/common';

import choiceOfTheYearPdf from '../../assets/tmp/choice_of_the_year.pdf';

const Copyright = function() {
  const { t } = useTranslation();

  const common       = useCommon();
  const siteSettings = useSiteSettings();

  return (
    <div className={classNames('copyright', 'inline')}>
      <p>{siteSettings.data.FOOTER.COPYRIGHT}</p>{' '}
      <p>
        <span>{t('is_not_online_store')}</span>{' '}
        <Link
          to={common.getUrlByTemplate('policy-personal-data')}
        >
          {t('personal_data_processing_policy')}
        </Link>
        {', '}
        <Link to={common.getUrlByTemplate('cookie')}>
          {t('cookies_information')}
        </Link>
        {', '}
        <Link to={common.getUrlByTemplate('cookie-settings')}>
          {t('client_cookie_settings_link')}
        </Link>
        {', '}
        <Link to={common.getUrlByTemplate('cookies-list')}>
          {t('client_list_of_cookies')}
        </Link>
      </p>
      <FooterCookieBrowsersLinks />
      <div className={'copyright_wrapper'}>
        <p>
          {t('based_on')}{' '}
          <a
            href={choiceOfTheYearPdf}
            target={'_blank'}
            rel={'nofollow'}
          >
            {t('choice_of_the_year')}
          </a>
        </p>
      </div>
    </div>
  );
};

export default Copyright;